"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Spinner = _interopRequireDefault(require("../shapes/Spinner"));

var defaultNoDataText = 'Loading...';

var TableSpinner = function TableSpinner(_ref) {
  var loading = _ref.loading,
      loadingText = _ref.loadingText,
      entireHeaderHeight = _ref.entireHeaderHeight;

  if (!loading) {
    return null;
  }

  return _react["default"].createElement("div", {
    style: {
      position: 'absolute',
      left: 0,
      top: entireHeaderHeight,
      bottom: 0,
      width: '100%',
      backgroundColor: 'rgba(255,255,255,0.8)',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center'
    }
  }, _react["default"].createElement(_Spinner["default"], null), loadingText || defaultNoDataText);
};

TableSpinner.propTypes = {
  loading: _propTypes["default"].bool,
  loadingText: _propTypes["default"].node,
  entireHeaderHeight: _propTypes["default"].number
};
TableSpinner.defaultProps = {
  entireHeaderHeight: 0
};
var _default = TableSpinner;
exports["default"] = _default;